import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HelpUtils {
	focusTarget: HTMLElement;
	private refresh = new BehaviorSubject<{ focused: string; visible: string[] }>({ focused: '', visible: [''] });
	shallRefreshAnchors = this.refresh.asObservable();
	private initialized = false;

	init() {
		if (!this.initialized) {
			document.addEventListener('focusin', this.onFocusChange.bind(this));
			this.initialized = true;
		}
	}

	// Define the listener function
	onFocusChange(event) {
		this.focusTarget = event.target;
	}

	refreshAnchors() {
		this.refresh.next({ focused: this.getHelpAnchorForFocus(), visible: this.getHelpAnchorsForVisibleElements() });
	}

	private readonly ATTRIBUTE_NAME_HELP_ANCHOR = 'data-help-anchor';

	getHelpAnchorForFocus(): string {
		let element: HTMLElement | null = this.focusTarget;

		while (element) {
			if (element.hasAttribute(this.ATTRIBUTE_NAME_HELP_ANCHOR)) {
				return element.getAttribute(this.ATTRIBUTE_NAME_HELP_ANCHOR);
			}
			element = element.parentElement; // Move to the parent element
		}
		return '';
	}

	getHelpAnchorsForVisibleElements(): string[] {
		const helpAnchors: string[] = [''];
		let lastAnchor = '';

		function addAnchor(anchor: string) {
			if (anchor !== lastAnchor) {
				helpAnchors.push(anchor);
				lastAnchor = anchor;
			}
		}

		function recurse(element: HTMLElement, _this: HelpUtils) {
			if (element.hasAttribute(_this.ATTRIBUTE_NAME_HELP_ANCHOR) && _this.isPartiallyVisible(element)) {
				addAnchor(element.getAttribute(_this.ATTRIBUTE_NAME_HELP_ANCHOR));
			}

			Array.from(element.children).forEach(child => recurse(child as HTMLElement, _this));
		}

		recurse(this.getAnchorSearchRoot(), this);
		return helpAnchors;
	}

	private getAnchorSearchRoot(): HTMLElement {
		const dialogContainers = document.querySelectorAll<HTMLElement>(
			'.cdk-overlay-container .cdk-overlay-pane .mat-mdc-dialog-container, ' +
				'.cdk-overlay-container .cdk-overlay-pane .mat-dialog-container, ' +
				'.cdk-overlay-container .cdk-overlay-pane mat-dialog-container'
		);

		if (dialogContainers.length > 0) {
			return dialogContainers[dialogContainers.length - 1];
		}

		return document.documentElement;
	}

	// berücksichtigt nicht, ob Element verdeckt ist - Links für Elemente der Seite werden auch berücksichtigt, wenn
	// ein Dialog offen ist.
	isPartiallyVisible(element: HTMLElement): boolean {
		const rect = element.getBoundingClientRect();
		return (
			rect.bottom > rect.top &&
			rect.right > rect.left &&
			rect.bottom > 0 &&
			rect.right > 0 &&
			rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left < (window.innerWidth || document.documentElement.clientWidth)
		);
	}
}
